import { useState } from 'react';
import type { AccountUserRole } from 'vopay';
import { api } from '@/services/api.config';

export default function useFetchAccountUserRoles() {
  const [fetching, setFetching] = useState(false);
  const [roles, setRoles] = useState<AccountUserRole[]>([]);

  async function fetchAccountUserRoles(bearer?: string) {
    try {
      setFetching(true);
      const res = await api.fetchAccountUserRoles(bearer);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      setRoles(res.Roles);

      return res;
    } catch (error) {
      console.error('Fetch account user roles failed:', error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  return { fetching, roles, fetchAccountUserRoles };
}
